export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6486.16b8c455.jpg";